export { FeatureBento } from "../feature-bento"
export type { FeatureBentoProps, FeatureBentoItem } from "../feature-bento"
